import { render, staticRenderFns } from "./ServidoresOLTPlacas.vue?vue&type=template&id=07355920&"
import script from "./ServidoresOLTPlacas.vue?vue&type=script&lang=js&"
export * from "./ServidoresOLTPlacas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports